import axios from 'axios'
//constantes
const dataInicial = {
    dataempleado: [{}],
    empleadoactivo: [
        {
           
        }
    ]

}



//types
const OBTENER_EMPLEADO_ACTIVO = 'OBTENER_EMPLEADO_ACTIVO'
const OBTENER_DETALLE_DE_EMPLEADO_GENERAL = 'OBTENER_DETALLE_DE_EMPLEADO_GENERAL'
const { REACT_APP_API_URL } = process.env;
//reducer
export default function EmpleadoReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_DETALLE_DE_EMPLEADO_GENERAL:
            return { ...state, dataempleado: action.payload }
        case OBTENER_EMPLEADO_ACTIVO:
            return { ...state, empleadoactivo: action.payload }
        default:
            return state
    }
}
//acciones
export const obtenerdetallempleado = (bd, id) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/empleados/info?guidempresa=${bd}&idempleado=${id}`, requestOptions)
        dispatch({
            type: OBTENER_DETALLE_DE_EMPLEADO_GENERAL,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}

export const obtenerempleadoactivo = (bd, depta) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/empleados/depto?guidempresa=${bd}&iddepartamento=${depta}`, requestOptions)
        dispatch({
            type: OBTENER_EMPLEADO_ACTIVO,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
        
    }
}